import { React, useState } from "react";
import { TypeAnimation } from 'react-type-animation';
import MessageHeatmap from './MessageHeatmap';
import MessageTimeOfDay from "./MessageTimeOfDay";
import YearlySummary from "./YearlySummary";

const MessageSummary = ({ user, summaryData, frequencyData, timeOfDayData }) => {

  const [currentStep, setCurrentStep] = useState(0);

  const totalMessages = summaryData.reduce((sum, yearSummary) => sum += parseInt(yearSummary.dm_gm_total), 0).toLocaleString('en-US')

  function formatDate(dateString) {
    const date = new Date(dateString)
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

  const steps = [
    {
      text: `Hello, ${user.first_name}.\n\n`,
      render: () => {
      }
    },
    {
      text: `We've exchanged over ${totalMessages} messages. Our first exchange was on ${formatDate(frequencyData[0].date)}.`,
      render: () => (
        <div className="container container-stat fade-in">
          <YearlySummary summaryData={summaryData} />
        </div>
      )
    },
    {
      text: `Here's a heatmap showing our communication over time:`,
      render: () => (
        <div className="fade-in">
          <MessageHeatmap 
            frequencyData={frequencyData}
          />
        </div>
      )
    },
    {
      text: `When are we most active? Here's a chart showing when in the day we tend to communicate.`,
      render: () => (
        <div className="fade-in">
          <MessageTimeOfDay 
            timeOfDayData={timeOfDayData}
          />
        </div>
      )
    }
  ];

  return (
    <div>
      {steps.map((step, index) => (
        <div key={index}>
          {currentStep >= index && (
            <TypeAnimation
              sequence={[
                1000,
                step.text,
                500,
                () => setCurrentStep(currentStep + 1)
              ]}
              speed={99}
              style={{ whiteSpace: 'pre-line', display: 'block' }}
              cursor={false}
            />
          )}
          {currentStep > index && step.render()}
        </div>
      ))}
    </div>
  );
};

export default MessageSummary;
